// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface UserBoxIconSignature {
  Element: SVGSVGElement;
}

export const UserBoxIcon: TOC<UserBoxIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<g clip-path="url(#clip0_1008_2882)">
<path d="M8.25101 17C8.25101 14.699 9.70001 13.25 12.001 13.25C14.302 13.25 15.751 14.699 15.751 17H8.25101Z"/>
<path d="M13.7688 7.73223C14.7451 8.70854 14.7451 10.2915 13.7688 11.2678C12.7925 12.2441 11.2096 12.2441 10.2333 11.2678C9.25696 10.2915 9.25696 8.70854 10.2333 7.73223C11.2096 6.75592 12.7925 6.75592 13.7688 7.73223Z"/>
<path d="M20.001 22H16.001V20H20.001V16H22.001V20C22.001 21.103 21.104 22 20.001 22Z"/>
<path d="M22.001 8H20.001V4H16.001V2H20.001C21.104 2 22.001 2.896 22.001 4V8Z"/>
<path d="M4.00101 8H2.00101V4C2.00101 2.896 2.89801 2 4.00101 2H8.00101V4H4.00101V8Z"/>
<path d="M8.00101 22H4.00101C2.89801 22 2.00101 21.103 2.00101 20V16H4.00101V20H8.00101V22Z"/>
</g>
<defs>
<clipPath id="clip0_1008_2882">
<rect width="24" height="24"/>
</clipPath>
</defs>
</svg>
</template>;